import { useState, useEffect, useCallback, useRef } from 'react';
import { supabase } from './supabase';
import { loadProfile, saveProfile } from './db';
import Auth from './Auth';
import Toto from './Toto_app_v6';

const F = "'Nunito', sans-serif";

function ResetPassword() {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleReset = async () => {
    if (!password || password.length < 6) { setError('Password must be at least 6 characters'); return; }
    if (password !== confirm) { setError('Passwords do not match'); return; }
    setLoading(true); setError('');
    const { error } = await supabase.auth.updateUser({ password });
    if (error) setError(error.message);
    else setSuccess(true);
    setLoading(false);
  };

  const inp = { width: '100%', padding: '13px 14px', borderRadius: 12, border: '1.5px solid #E2E8F0', fontSize: 14, fontFamily: F, outline: 'none', color: '#2D3748', boxSizing: 'border-box', marginBottom: 14, background: '#fff' };

  return (
    <div style={{ minHeight: '100vh', background: '#F0F2F5', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div style={{ background: '#fff', borderRadius: 24, padding: '40px 28px', width: '100%', maxWidth: 400, border: '1.5px solid #E2E8F0', boxShadow: '0 4px 24px rgba(0,0,0,0.08)' }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={{ width: 64, height: 64, borderRadius: 18, background: '#E8394D', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 12px', boxShadow: '0 4px 16px #E8394D44' }}>
            <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="white" strokeWidth="2.2" strokeLinecap="round"><rect x="3" y="11" width="18" height="10" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg>
          </div>
          <div style={{ fontSize: 22, fontFamily: F, fontWeight: 900, color: '#1A202C' }}>Set New Password</div>
          <div style={{ fontSize: 13, fontFamily: F, color: '#A0AEC0', marginTop: 4 }}>Enter your new password below</div>
        </div>
        {success ? (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>✅</div>
            <div style={{ fontSize: 18, fontFamily: F, fontWeight: 900, color: '#2D3748', marginBottom: 8 }}>Password Updated!</div>
            <div style={{ fontSize: 13, fontFamily: F, color: '#718096', marginBottom: 24 }}>Your password has been reset. You can now sign in.</div>
            <button onClick={() => window.location.href = '/'} style={{ width: '100%', padding: '15px', borderRadius: 14, border: 'none', background: '#E8394D', color: '#fff', fontSize: 15, fontFamily: F, fontWeight: 900, cursor: 'pointer' }}>
              Go to Sign In →
            </button>
          </div>
        ) : (
          <>
            <div style={{ fontSize: 11, fontFamily: F, fontWeight: 800, color: '#A0AEC0', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 6 }}>New Password</div>
            <input style={inp} type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="At least 6 characters" />
            <div style={{ fontSize: 11, fontFamily: F, fontWeight: 800, color: '#A0AEC0', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 6 }}>Confirm Password</div>
            <input style={{ ...inp, marginBottom: 20 }} type="password" value={confirm} onChange={e => setConfirm(e.target.value)} placeholder="Repeat new password" onKeyDown={e => e.key === 'Enter' && handleReset()} />
            {error && <div style={{ background: '#FFF5F5', border: '1px solid #FEB2B2', borderRadius: 10, padding: '10px 14px', fontSize: 13, fontFamily: F, color: '#E8394D', fontWeight: 700, marginBottom: 14 }}>⚠ {error}</div>}
            <button onClick={handleReset} disabled={loading} style={{ width: '100%', padding: '15px', borderRadius: 14, border: 'none', background: loading ? '#E2E8F0' : '#E8394D', color: loading ? '#A0AEC0' : '#fff', fontSize: 15, fontFamily: F, fontWeight: 900, cursor: loading ? 'not-allowed' : 'pointer' }}>
              {loading ? 'Updating...' : 'Update Password →'}
            </button>
          </>
        )}
      </div>
    </div>
  );
}

function App() {
  const [user, setUser]                       = useState(null);
  const [profile, setProfile]                 = useState(null);
  const [ready, setReady]                     = useState(false);
  const [isPasswordReset, setIsPasswordReset] = useState(false);
  const [isNewUser, setIsNewUser]               = useState(false);
  const [subStatus, setSubStatus]               = useState(null);


  const handledRef                            = useRef(false);
  const userInitiatedSignOut                  = useRef(false);

  const mapProfile = (p) => !p ? null : ({
    daycareN:  p.daycare_name,
    providerN: p.provider_name,
    licenseN:  p.license_number,
    sspsN:     p.ssps_number,
    address:   p.address,
    city:      p.city,
    zip:       p.zip,
    capacity:  p.capacity,
    wccc:      p.wccc,
    bundle:    p.plan,
    email:     p.email,
  });

  const handleSession = useCallback(async (sessionUser) => {
    if (!sessionUser) {
      setUser(null);
      setProfile(null);
      setReady(true);
      return;
    }
    setUser(sessionUser);
    // Run profile load and subscription check in parallel
    const profilePromise = Promise.race([
      loadProfile(sessionUser.id),
      new Promise((_, reject) => setTimeout(() => reject(new Error('loadProfile timeout')), 8000))
    ]);

    const subPromise = navigator.onLine
      ? fetch('/api/check-subscription', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email: sessionUser.email }),
        }).then(r => r.json()).then(d => d.status || 'unknown').catch(() => 'active')
      : Promise.resolve('active');

    const [profileResult, subStatus] = await Promise.allSettled([profilePromise, subPromise]);

    // Handle profile
    if (profileResult.status === 'fulfilled') {
      const p = profileResult.value;
      console.log('profile loaded:', p?.daycare_name);
      setProfile(mapProfile(p));
      setIsNewUser(p === null);
    } else {
      console.error('loadProfile error or timeout:', profileResult.reason?.message);
      setIsNewUser(false);
    }

    // Handle subscription
    setSubStatus(subStatus.status === 'fulfilled' ? subStatus.value : 'active');
    handledRef.current = true;
    setReady(true);
  }, []);

  useEffect(() => {
    const { data: { subscription } } = supabase.auth.onAuthStateChange(async (event, session) => {
      console.log('auth event:', event, session?.user?.email);

      if (event === 'PASSWORD_RECOVERY') {
        setIsPasswordReset(true);
        setReady(true);
        handledRef.current = true;
        return;
      }

      if (event === 'INITIAL_SESSION') {
        await handleSession(session?.user || null);
      }

      if (event === 'SIGNED_IN') {
        // Skip — INITIAL_SESSION already handled this on first load
        return;
      }
      if (event === 'TOKEN_REFRESHED') {
        // Just update the user object — don't reload profile or subscription
        if (session?.user) setUser(session.user);
        return;
      }

      if (event === 'SIGNED_OUT') {
        // Supabase fires SIGNED_OUT on failed token refresh (weak signal, backgrounded app).
        // Only clear state when the user explicitly tapped Sign Out.
        if (!userInitiatedSignOut.current) {
          console.log('SIGNED_OUT ignored — not user-initiated, autoRefreshToken will retry');
          setReady(true);
          return;
        }
        userInitiatedSignOut.current = false;
        handledRef.current = true;
        setUser(null);
        setProfile(null);
        setIsPasswordReset(false);
        setReady(true);
      }
    });

    const timeout = setTimeout(() => {
      if (!handledRef.current) {
        console.log('fallback timeout');
        setReady(true);
      }
    }, 5000);

    return () => {
      subscription.unsubscribe();
      clearTimeout(timeout);
    };
  }, [handleSession]);

  // Handle return from Stripe
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("payment") === "cancelled") {
      localStorage.removeItem("toto_pending_profile");
      window.history.replaceState({}, "", "/");
    }
    if (params.get("subscribe") === "true") {
      window.history.replaceState({}, "", "/");
      if (user) {
        fetch('/api/customer-portal', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email: user.email }),
        })
          .then(r => r.json())
          .then(data => { if (data.url) window.location.href = data.url; })
          .catch(err => console.error('Portal error:', err));
      }
    }
    if (params.get("payment") === "success") {
      if (!user) return;
      const pending = localStorage.getItem("toto_pending_profile");
      if (pending) {
        const p = JSON.parse(pending);
        localStorage.removeItem("toto_pending_profile");
        handleSaveProfile(p);
        fetch('/api/send-welcome-email', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            providerName: p.providerN,
            daycareName: p.daycareN,
            email: user.email,
          }),
        }).catch(err => console.error('Welcome email error:', err));
        fetch('/api/send-signup-notification', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            providerName: p.providerN,
            daycareName: p.daycareN,
            email: user.email,
          }),
        }).catch(err => console.error('Notification email error:', err));
        window.history.replaceState({}, "", "/");
      }
    }
  }, [user]);

  const handleSaveProfile = async (p) => {
    setProfile(p);
    if (user) await saveProfile(user.id, { ...p, email: user.email });
  };

  const handleSignOut = useCallback(async () => {
    userInitiatedSignOut.current = true;
    await supabase.auth.signOut();
  }, []);

  if (!ready) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#FAFAF9', fontFamily: F, fontSize: 16, color: '#A0AEC0' }}>
      Loading...
    </div>
  );

  if (isPasswordReset) return <ResetPassword />;

  if (!user) return (
    <Auth onAuth={async (u) => {
      await handleSession(u);
    }} />
  );

  const isBlocked = subStatus && !['active', 'trialing', 'no_customer', 'no_subscription', 'unknown'].includes(subStatus);

  if (isBlocked) return (
    <div style={{ minHeight: '100vh', background: '#F0F2F5', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20, fontFamily: F }}>
      <div style={{ background: '#fff', borderRadius: 24, padding: '40px 28px', width: '100%', maxWidth: 400, border: '1.5px solid #E2E8F0', boxShadow: '0 4px 24px rgba(0,0,0,0.08)', textAlign: 'center' }}>
        <div style={{ width: 64, height: 64, borderRadius: 18, background: '#991B1B', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px', boxShadow: '0 4px 16px rgba(153,27,27,0.3)' }}>
          <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="white" strokeWidth="2.2" strokeLinecap="round"><rect x="3" y="11" width="18" height="10" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg>
        </div>
        <div style={{ fontSize: 22, fontWeight: 900, color: '#1A202C', marginBottom: 8 }}>Subscription Inactive</div>
        <div style={{ fontSize: 14, color: '#718096', marginBottom: 24, lineHeight: 1.6 }}>
          Your subscription has expired or been cancelled. Reactivate to continue using TotoCare.
        </div>
        <button onClick={async () => {
          try {
            const r = await fetch('/api/customer-portal', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email: user.email }) });
            const d = await r.json();
            if (d.url) window.location.href = d.url;
          } catch(e) { alert('Could not open billing portal. Please contact support@totocare.app'); }
        }} style={{ display: 'block', width: '100%', padding: '15px', borderRadius: 14, background: '#991B1B', color: '#fff', fontSize: 15, fontWeight: 900, border: 'none', cursor: 'pointer', marginBottom: 12 }}>
          Reactivate Subscription →
        </button>
        <button onClick={handleSignOut} style={{ width: '100%', padding: '13px', borderRadius: 14, border: '1.5px solid #E2E8F0', background: 'transparent', color: '#718096', fontSize: 14, fontWeight: 700, cursor: 'pointer' }}>
          Sign Out
        </button>
      </div>
    </div>
  );

  return <Toto key={user.id} user={user} profile={profile} onSaveProfile={handleSaveProfile} isNewUser={isNewUser} onSignOut={handleSignOut} />;
}

export default App;
